import React, { useEffect } from "react";

const TermsOfService = () => {
  // Scroll reveal effect
  useEffect(() => {
    const revealElements = document.querySelectorAll(".scroll-reveal");
    const handleScroll = () => {
      revealElements.forEach((el) => {
        const top = el.getBoundingClientRect().top;
        if (top < window.innerHeight - 50) {
          el.classList.add("revealed");
        }
      });
    };
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className="min-h-screen py-16 px-4 md:px-20"
      style={{ backgroundColor: "var(--bg-1)", color: "var(--brand-dark)" }}
    >
      <div className="container-custom">
        {/* Heading */}
        <h1
          className="text-4xl md:text-5xl font-bold mb-12 scroll-reveal text-center"
          style={{ transitionDelay: "0.2s" }}
        >
          Terms of Service
        </h1>

        {/* Acceptance of Terms */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Acceptance of Terms
          </h2>
          <p className="text-lg leading-relaxed">
            By accessing or using the DVV Projects website, you agree to be
            bound by these Terms of Service. If you do not agree, please do not
            use our website.
          </p>
        </section>

        {/* User Responsibilities */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            User Responsibilities
          </h2>
          <p className="text-lg leading-relaxed">
            Users agree to use the website responsibly and not engage in
            activities that may damage the website, violate any laws, or
            infringe on the rights of others.
          </p>
        </section>

        {/* Intellectual Property */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Intellectual Property
          </h2>
          <p className="text-lg leading-relaxed">
            All content, images, text, and materials on the DVV Projects website
            are the property of DVV Projects and protected by intellectual
            property laws. You may not copy, distribute, or reproduce any
            content without prior written consent.
          </p>
        </section>

        {/* Use of Website Information */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Use of Information
          </h2>
          <p className="text-lg leading-relaxed">
            The information collected from users may be used to provide
            services, improve website functionality, respond to inquiries, and
            send newsletters or promotional offers.
          </p>
        </section>

        {/* Limitation of Liability */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Limitation of Liability
          </h2>
          <p className="text-lg leading-relaxed">
            DVV Projects shall not be liable for any damages arising from the
            use of this website, including direct, indirect, incidental, or
            consequential damages.
          </p>
        </section>

        {/* Third-Party Services */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Third-Party Services
          </h2>
          <p className="text-lg leading-relaxed">
            Our website may contain links to third-party services. DVV Projects
            is not responsible for the content or practices of third-party
            websites.
          </p>
        </section>

        {/* Cookies & Tracking */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Cookies & Tracking
          </h2>
          <p className="text-lg leading-relaxed">
            We may use cookies and similar tracking technologies to enhance user
            experience and analyze website usage. You can manage cookies through
            your browser settings.
          </p>
        </section>

        {/* Contact Us */}
        <section className="mb-8 md:mb-12 scroll-reveal">
          <h2 className="text-3xl font-semibold mb-4 text-brand-dark">
            Contact Us
          </h2>
          <p className="text-lg leading-relaxed">
            For questions regarding these Terms of Service, contact us at:
          </p>
          <ul className="mt-2 text-lg">
            <li>
              <strong>Phone:</strong>{" "}
              <span className="text-brand-gold">+91 7288080999</span>
            </li>
            <li>
              <strong>Email:</strong>{" "}
              <span className="text-brand-gold font-semibold">
                info@dvvprojects.com
              </span>
            </li>
            <li>
              <strong>Address:</strong>
             <div className="text-brand-gold mt-1 break-words">
  <strong>Head Office:</strong><br />
  2nd Floor, 28-18-9, Timpany School Road,<br />
  Opposite Indian Overseas Bank, Vuda Colony,<br />
  Gonthinavanipalem, Gajuwaka,<br />
  Visakhapatnam, Andhra Pradesh 530026
  <br /><br />

  <strong>Branch Office:</strong><br />
  D.No 49-49-6, First Floor,<br />
  Beside Arka Hospital, Santhipuram,<br />
  Akkayyapalem,<br />
  Visakhapatnam, Andhra Pradesh 530016
</div>
            </li>
          </ul>
        </section>

        {/* Last Updated */}
        <section className="mb-12 scroll-reveal">
          <p className="text-lg text-gray-600 italic">
            Last updated: 26 December 2025
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfService;
